import type { ExperimentConfig } from '../@types'

const config: ExperimentConfig[] = [
	{
		female: {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=female&exp=web_ui_multichange_planpicker~1
			paywall: {
				experiment: () =>
					import(
						/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/experiments/web_ui_multichange_planpicker/__b'
					),
			},
		},
		'female-water-fasting': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=female-water-fasting&exp=web_ui_multichange_planpicker~1
			paywall: {
				experiment: () =>
					import(
						/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/experiments/web_ui_multichange_planpicker/__b'
					),
			},
		},
	},
	{
		female: {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=female&exp=web_ui_multichange_planpicker~2
			paywall: {
				experiment: () =>
					import(
						/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/experiments/web_ui_multichange_planpicker/__c'
					),
			},
		},
		'female-water-fasting': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=female-water-fasting&exp=web_ui_multichange_planpicker~2
			paywall: {
				experiment: () =>
					import(
						/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/experiments/web_ui_multichange_planpicker/__c'
					),
			},
		},
	},
	{
		female: {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=female&exp=web_ui_multichange_planpicker~3
			paywall: {
				experiment: () =>
					import(
						/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/experiments/web_ui_multichange_planpicker/__d'
					),
			},
		},
		'female-water-fasting': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=female-water-fasting&exp=web_ui_multichange_planpicker~3
			paywall: {
				experiment: () =>
					import(
						/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/experiments/web_ui_multichange_planpicker/__d'
					),
			},
		},
	},
]

export default config
